// extracted by mini-css-extract-plugin
export default {"bg":"Offer_bg__iUvPC","offer":"Offer_offer__o215g","invest":"Offer_invest__n1kNn","cards":"Offer_cards__+U5xN","card":"Offer_card__Fd-Bo","cube":"Offer_cube__i0apQ"};